import { layoutModel } from 'layout/main-layout';
import { useOutletContext as useOutletContextDefault } from 'react-router-dom';

export const useOutletContext = useOutletContextDefault<layoutModel.OutletContext>;
